const WALLET_COLORS = [
    '#22d3ee',
    '#c084fc',
    '#a3e635',
    '#f472b6',
    '#2dd4bf',
    '#fde047',
    '#818cf8',
    '#fb7185',
];

export function walletColors(wallets: readonly string[]): Map<string, string> {
    return new Map(
        wallets.map((w, i) => [w, WALLET_COLORS[i % WALLET_COLORS.length]])
    );
}
